var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tabs-content", attrs: { eager: "" } }, [
    _c("div", { staticClass: "tabs-content__tabs" }, [
      _c("div", { staticClass: "tabs-content__wrapper" }, [
        _c(
          "div",
          { staticClass: "tabs-content__row tabs-content__header" },
          _vm._l(_vm.tabs, function(tab) {
            return _c(
              "button",
              {
                key: tab.title,
                class: [
                  "tabs-content__tabs-btn",
                  { "tabs-content__tabs-btn--selected": tab.isSelected }
                ],
                on: {
                  click: function($event) {
                    return _vm.selectTab(tab.title)
                  }
                }
              },
              [_vm._v("\n          " + _vm._s(tab.title) + "\n        ")]
            )
          }),
          0
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "tabs-content__wrapper" }, [
      _c("div", { staticClass: "tabs-content__row" }, [_vm._t("default")], 2)
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }